/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_CoursesInputs */

const zh_course_courses = /** @type {(inputs: Course_CoursesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的课程`)
};

const en_course_courses = /** @type {(inputs: Course_CoursesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Courses`)
};

const es_course_courses = /** @type {(inputs: Course_CoursesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mis Cursos`)
};

/**
* | output |
* | --- |
* | "My Courses" |
*
* @param {Course_CoursesInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const course_courses = /** @type {((inputs?: Course_CoursesInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_CoursesInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_course_courses(inputs)
	if (locale === "en") return en_course_courses(inputs)
	return es_course_courses(inputs)
});